import { render, staticRenderFns } from "./EditHotSign.vue?vue&type=template&id=2eb347e8&scoped=true&lang=pug&"
import script from "./EditHotSign.vue?vue&type=script&lang=js&"
export * from "./EditHotSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb347e8",
  null
  
)

export default component.exports